import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=e32c5ed0&scoped=true"
import script from "./WaterMark.vue?vue&type=script&lang=ts"
export * from "./WaterMark.vue?vue&type=script&lang=ts"
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=e32c5ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32c5ed0",
  null
  
)

export default component.exports